// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#previewVideo.container__preview-video iframe{max-height:30vw!important;max-width:100%!important;background-color:#000!important}.img-content{display:flex;justify-content:center;align-items:center;text-align:center!important;width:170px!important;height:100px!important}.text-media__required{width:100%;margin-top:.25rem;font-size:80%;color:#f83245}", ""]);
// Exports
module.exports = exports;
